module.exports = __webpack_public_path__ + "static/media/greencard.9b64e6dd.svg";